export const CLINICAL_NOTE_STRUCTURES = [
  {
    key: 'SOAP',
    label: 'SOAP',
    description: 'Subjective, Objective, Assessment, Plan',
    sections: ['Subjective', 'Objective', 'Assessment', 'Plan']
  },
  {
    key: 'SOAPIE',
    label: 'SOAPIE',
    description: 'Subjective, Objective, Assessment, Plan, Implementation, Evaluation',
    sections: ['Subjective', 'Objective', 'Assessment', 'Plan', 'Implementation', 'Evaluation']
  },
  {
    key: 'DAP',
    label: 'DAP',
    description: 'Data, Assessment, Plan',
    sections: ['Data', 'Assessment', 'Plan']
  },
  {
    key: 'PIE',
    label: 'PIE',
    description: 'Problem, Intervention, Evaluation',
    sections: ['Problem', 'Intervention', 'Evaluation']
  },
  {
    key: 'APIE',
    label: 'APIE',
    description: 'Assessment, Plan, Implementation, Evaluation',
    sections: ['Assessment', 'Plan', 'Implementation', 'Evaluation']
  },
  {
    key: 'SBAR',
    label: 'SBAR',
    description: 'Situation, Background, Assessment, Recommendation',
    sections: ['Situation', 'Background', 'Assessment', 'Recommendation']
  },
  {
    key: 'BIRP',
    label: 'BIRP',
    description: 'Behavior, Intervention, Response, Plan',
    sections: ['Behavior', 'Intervention', 'Response', 'Plan']
  },
  {
    key: 'H&P',
    label: 'H&P',
    description: 'History & Physical',
    sections: [
      'Chief Complaint',
      'History of Present Illness',
      'Past Medical History',
      'Physical Examination',
      'Assessment',
      'Plan'
    ]
  },
  {
    key: 'CUSTOM',
    label: 'Custom Template',
    description: 'User-defined custom template',
    sections: []
  }
]

export const getStructureByKey = (key) => {
  return CLINICAL_NOTE_STRUCTURES.find((structure) => structure.key === key)
}

export const getStructureOptions = () => {
  return CLINICAL_NOTE_STRUCTURES.map((structure) => ({
    value: structure.key,
    label: `Structure: ${structure.label}`,
    description: structure.description
  }))
}
